export default __webpack_public_path__ + "static/media/image2.ac752b35.jpg";